// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================= TOP KPI STRIP ================= */

.commandStatusStrip {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 16px;
}

.statusTile {
  min-width: 0;
  border: 1px solid rgba(177, 136, 0, 0.28);
  border-radius: 18px;
  padding: 16px 18px;
  background:
    linear-gradient(180deg, rgba(177, 136, 0, 0.08), rgba(255, 255, 255, 0.025)),
    rgba(8, 10, 16, 0.92);
  box-shadow:
    0 14px 34px rgba(0, 0, 0, 0.28),
    inset 0 1px 0 rgba(255, 255, 255, 0.045);
}

.statusTile span {
  display: block;
  margin-bottom: 8px;
  color: rgba(238, 242, 255, 0.58);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.statusTile strong {
  display: block;
  color: #f8fafc;
  font-size: 1.35rem;
  font-weight: 800;
  line-height: 1.15;
}

.statusTile small {
  display: block;
  margin-top: 8px;
  color: rgba(238, 242, 255, 0.62);
  font-size: 0.78rem;
  font-weight: 600;
}

.statusTile .positive,
.statusTile small.positive {
  color: #37d67a;
}

.statusTile .negative,
.statusTile small.negative {
  color: #ff5c7a;
}

@media (max-width: 1100px) {
  .commandStatusStrip {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .commandStatusStrip {
    grid-template-columns: 1fr;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Styles/CommandStatusStrip.css"],"names":[],"mappings":"AAAA,sDAAsD;;AAEtD;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,yCAAyC;EACzC,mBAAmB;EACnB,kBAAkB;EAClB;;yBAEuB;EACvB;;4CAE0C;AAC5C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":["/* ================= TOP KPI STRIP ================= */\n\n.commandStatusStrip {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 14px;\n  margin-bottom: 16px;\n}\n\n.statusTile {\n  min-width: 0;\n  border: 1px solid rgba(177, 136, 0, 0.28);\n  border-radius: 18px;\n  padding: 16px 18px;\n  background:\n    linear-gradient(180deg, rgba(177, 136, 0, 0.08), rgba(255, 255, 255, 0.025)),\n    rgba(8, 10, 16, 0.92);\n  box-shadow:\n    0 14px 34px rgba(0, 0, 0, 0.28),\n    inset 0 1px 0 rgba(255, 255, 255, 0.045);\n}\n\n.statusTile span {\n  display: block;\n  margin-bottom: 8px;\n  color: rgba(238, 242, 255, 0.58);\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.statusTile strong {\n  display: block;\n  color: #f8fafc;\n  font-size: 1.35rem;\n  font-weight: 800;\n  line-height: 1.15;\n}\n\n.statusTile small {\n  display: block;\n  margin-top: 8px;\n  color: rgba(238, 242, 255, 0.62);\n  font-size: 0.78rem;\n  font-weight: 600;\n}\n\n.statusTile .positive,\n.statusTile small.positive {\n  color: #37d67a;\n}\n\n.statusTile .negative,\n.statusTile small.negative {\n  color: #ff5c7a;\n}\n\n@media (max-width: 1100px) {\n  .commandStatusStrip {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 640px) {\n  .commandStatusStrip {\n    grid-template-columns: 1fr;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
